export const getDataAttr = (value: boolean | undefined) =>
  value ? 'true' : undefined
